import { createSelector } from "@reduxjs/toolkit";
import { selectPricingState } from "../selectors";

export const selectGlobalGuaranteesReferential = createSelector(
  [selectPricingState],
  (pricingState) => {
    return {
      hasOptionalGuarantees: pricingState.globalGuaranteesReferential.optional.length > 0,
      globalGuaranteesReferential: pricingState.globalGuaranteesReferential,
    }
  }
)

export const selectGlobalGuarantees = createSelector(
  [selectPricingState],
  (pricingState) => pricingState.globalGuarantees
)

export const selectGlobalGuaranteeIds = createSelector(
  [selectPricingState],
  (pricingState) => {
    return [
      ...pricingState.globalGuarantees.mandatory.map(g => g.id),
      ...pricingState.globalGuarantees.optional.map(g => g.id),
    ]
  }
)

export const selectGuaranteeLastResearchHash = createSelector(
  [selectPricingState],
  (pricingState) => pricingState.guaranteeLastResearchHash
)
